<template>
	<div class="course_detail_container" @contextmenu.prevent="handleContextMenu" @keydown="handleGlobalKeyDown">
		<div v-if="detailData">
			<div style="width: 100%;display: flex; flex-direction: column; align-items: center;">
				<!-- <div style="width: 100%;height: 400px;;display: flex; flex-direction: column; align-items: center;background: #FEECDA;"> -->
				<!-- <div style="width: 100%;height: 400px;;display: flex; flex-direction: column; align-items: center;"> -->
				<!-- <div style="display: flex; flex-direction: column;width: 1200px; max-width: 1200px; box-sizing: border-box;">
					<div class="mianb">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item :to="{ path: '/' }">视频课</el-breadcrumb-item>
							<el-breadcrumb-item :to="{ path: '/course/list' }">课程列表</el-breadcrumb-item>
							<el-breadcrumb-item :to="{ path: '/' }">课程介绍</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</div> -->
				
				<div id="top" style="display: flex; flex-direction: column;width: 1030px; height: 256px; margin-top: 150px;border-radius: 30px 30px 0 0;" :style="{'background':colorSelected ? colorSelected.bgColor :'#7c8cd4','color': colorSelected && colorSelected.fontColor ? colorSelected.fontColor:'#333'}">
					<!-- <img style="width: 100%;" src="../../assets/images/banner_course_detail.png" /> -->
					<img ref="myImg" id="myImg" :src="detailData.img_url_tt" crossorigin="anonymous" alt="" style="display: none;" />
					<div style="width: 100%; height: 211px;display: flex; flex-direction: row; position: relative; padding: 30px 40px 30px 440px; box-sizing: border-box;">
						<img v-if="detailData.teacher_list && detailData.teacher_list.length>0 && detailData.id!='p_65041d3680f6b894ec69b29f'" :src="detailData.teacher_list[0].img_url_compressed" style="width: 360px; position: absolute; bottom: 0; left: 90px;"/>
						<img v-if="detailData.teacher_list && detailData.teacher_list.length>0 && detailData.id=='p_65041d3680f6b894ec69b29f'" :src="detailData.teacher_list[0].img_url_compressed" style="width: 340px; position: absolute; bottom: 0; left: 90px;"/>
						<img v-if="!detailData.teacher_list || (detailData.teacher_list && detailData.teacher_list.length==0)" src="../../assets/images/avatar.png" style="width: 360px; position: absolute; bottom: 0; left: 90px;"/>
						<div style="display: flex;flex-direction: column; justify-content: space-between; line-height: 1;" :style="{'color': colorSelected  ? colorSelected.fontColor :'#333'}">
							<div style="display: flex;flex-direction: column;">
								<div style="font-size: 20px; margin-bottom: 10px;">课程：</div>
								<div style="font-size: 30px;font-weight: 600; line-height: 1.2; text-align: justify;display: -webkit-box;overflow: hidden;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;">
									{{detailData.title}}
								</div>	
							</div>
							<div style="display: flex; flex-direction: column; margin-top: 5px;" v-if="detailData.teacher_list && detailData.teacher_list.length>0">
								<div  style="font-size: 25px;margin-top: 5px;">{{detailData.teacher_list[0].name}}</div>
								<div style="margin-top: 10px;  font-size: 17px; ">
									<span v-if="detailData.teacher_list[0].school">{{detailData.teacher_list[0].school}}</span>
									<span v-if="detailData.teacher_list[0].school && detailData.teacher_list[0].title" style="margin: 0 2px;">/</span>
									<span v-if="detailData.teacher_list[0].title">{{detailData.teacher_list[0].title}}</span>
								</div>
							</div>
						</div>			
					</div>
				</div>

				<div id="top" style=" margin-top: -100px; display: flex; flex-direction: column;width: 830px; padding-top: 50px; ">
					<!-- <div style="width: 100%; height: 100%; display: flex;flex-direction: row;margin-bottom: 30px; ">
						<img style="width: 300px; height: 232px; box-shadow: 3px 5px 3px rgba(0,0,0,0.3);border: 1px solid #eee; margin-right: 64px;" :src="detailData.img_url_tt" />
						<div style="flex: 1;height: 232px; display:flex;flex-direction: column;  line-height: 1.2; padding-top: 15px; ;box-sizing: border-box;">
							<div style="font-size: 40px; color: #333; font-weight: 600;" v-html="detailData.title"></div>
							<div style="font-size: 30px; color: #333; margin-top: 35px;font-weight: 600;" v-html="detailData.author"></div>
							<div style="font-size: 18px; color: #333; margin-top: 12px;"></div>
						</div>
					</div> -->
					<div style=" width: 100%; height: 90px; display: flex; flex-direction: row; margin-bottom: -40px; z-index: 9;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); line-height: 1;">
						<div style="flex: 1; height: 90px;background-color: #fff; display: flex;flex-direction:column; ">
							<div style="width: 100%; height: 90px; overflow: hidden; display: flex; justify-content: center; align-items: center;">
								<img src="../../assets/images/bg_course_01.png" style="width: 70%;" />
							</div>
							<div style=" width: 100%; height: 90px; margin-top: -90px;  padding:20px 30px 10px 30px; box-sizing: border-box; display: flex;flex-direction:column; justify-content: space-between; ">
								<div v-if="priceShow" style="display: flex; flex-direction: column; width: 100%;">
									<div class="" style="display: flex; align-items:baseline;  color: #c83a2e;" v-if="detailData.price !='0.00'">
										<div style="color: #c83a2e; display: flex; align-items: flex-end;  margin-right: 10px;">
											<div style="font-size: 14px; font-weight: 600; margin-right: 5px;" v-if="detailData.line_price !=''">特惠价</div>
											<div style="font-size: 14px;">￥</div>
											<div style="font-size: 30px;margin-bottom: -3px; margin-left: -3px;">{{detailData.price}}</div>
										</div>
										<div v-if="detailData.line_price !=''" style="display: flex;font-size: 14px;color: #999; align-items: center; text-decoration: line-through;">
											￥{{detailData.line_price}}
										</div>
									</div>
									
									<div class="" style="display: flex; align-items: flex-end; line-height: 1;" v-if="detailData.price =='0.00' && detailData.line_price !=''">
										<div style="color: #999; display: flex; align-items: flex-end;  text-decoration: line-through; margin-right: 10px;">
											<div style="font-size: 14px;">￥</div>
											<div style="font-size: 30px;margin-bottom: -3px;">{{detailData.line_price}}</div>
										</div>
										<div style="color: #c83a2e;font-size: 14px; font-weight: 600;">限免</div>
									</div>
									
									<div class="" style="display: flex; line-height: 1;color: #c83a2e;font-size: 30px; font-weight: 600;" v-if="detailData.price =='0.00' && detailData.line_price ==''">
										免费
									</div>
								</div>
								<div v-else style="display: flex; line-height: 1;color: #c83a2e;font-size: 30px; font-weight: 600;">
									
								</div>

								<div class="" style="font-size:12px;color: #333;display: flex; flex-direction: row;">
									<div><i class="el-icon-time"></i> {{detailData.res_length}}</div>
									<div style="padding: 0 12px; margin:0 12px; border-left:1px solid #333; border-right:1px solid #333; ">
										{{detailData.res_count}}小节
									</div>
									<div>{{detailData.readers_count}}人正在学习</div>
								</div>
							</div>

						</div>
						<div style="display: flex; flex-direction: row; width: 290px; height:90px ;" v-if="detailData.price !='0.00' && priceShow">
							<div style="width: 100%;height:90px ; display: flex; flex-direction: row;" v-if="(detailData.status && detailData.status.status_code==2) || !isLogin">
								<div style="width: 90px; height: 90px; background: #FB9328 ; color:#fff ;font-size: 22px;cursor: pointer">
									<div style=" width: 90px; height: 90px;display: flex; flex-direction: column;justify-content: center;align-items: center; " @click="cartAddClick" v-if="detailData.is_cart_product==0">
										<i class="el-icon-shopping-cart-2" style="font-size: 36px; margin-bottom: 4px;"></i>
										<span style="font-size: 10px;">加入购物车</span>
									</div>
									<div style=" width: 90px; height: 90px;display: flex; flex-direction: column; justify-content: center;align-items: center; " @click="cartDelClick" v-if="detailData.is_cart_product==1">
										<i class="el-icon-shopping-cart-full" style="font-size: 36px;margin-bottom: 4px;"></i>
										<span style="font-size: 10px;">移出购物车</span>
									</div>
								</div>
								<div @click="showQrClick" style="width: 200px;height: 90px;display:flex;background: linear-gradient(to right,#c83a2e,#FB9328) ; color:#fff ; font-weight: 600; justify-content: center;align-items: center; font-size: 22px;cursor: pointer">
									立即订阅
								</div>
							</div>
							
							<div style="width: 100%;height:90px ; display: flex; flex-direction: row;" v-if="detailData.status && detailData.status.status_code==3">
								<div style="width: 90px; height: 90px; background-color: #fff;"></div>
								<div @click="showQrClick" style="width: 200px;height: 90px;display:flex;background: linear-gradient(to right,#c83a2e,#FB9328) ; color:#fff ; font-weight: 600; justify-content: center;align-items: center; font-size: 22px;cursor: pointer">
									立即兑换
								</div>
							</div>
							
							
						</div>
						
					</div>
				</div>
			</div>
			<div style="width: 100%; display: flex; flex-direction: row; justify-content: center;">
				<div id="videoContainer" style="display: flex; flex-direction: column;width: 1030px;max-width: 1030px;margin: 90px 0;">
					<div style=" width: 100%; ;display: flex; flex-direction: row; justify-content: center;">
						<div style="width:805px;">
							<div v-if="playerShow" ref="videoContainer" id="mse" style="width:100%; height: 460px; border: 1px solid #f1f1f1; border-top: none; background-color: #f1f1f1; box-sizing:border-box;">
								<!-- 视频播放区域 -->
							</div>

							<div v-if="!playerShow" style="width:100%; height: 460px;background:linear-gradient(to right top,#90ECA4,#5E80FC) ; font-size: 28px; color: #fff; display: flex;  justify-content: center;align-items: center; cursor: pointer;">
								
								<div v-if="detailData.is_office_product != 1">
									
									<div v-if="isLogin" @click="showQrClick">
										<p>您暂无权限播放本视频，请<span
											style="border-bottom: 1px solid #C43E32;color: #C43E32; padding: 0 0 2px 5px;" v-if="this.detailData.status && this.detailData.status.status_code == 2">订阅</span>
											<span
												style="border-bottom: 1px solid #C43E32;color: #C43E32; padding: 0 0 2px 5px;" v-if="this.detailData.status && this.detailData.status.status_code == 3">兑换</span>
										</p>
									</div>
									
									<div v-if="!isLogin" @click="toLogin">
										<p v-if="detailData.price !='0.00'">您暂无权限播放本视频，请<span
												style="border-bottom: 1px solid #C43E32;color: #C43E32; padding: 0 5px 2px 5px;">登录</span>订阅
										</p>
										<p v-else>您暂无权限播放本视频，请<span
												style="border-bottom: 1px solid #C43E32; color: #C43E32; padding: 0 0 2px 5px;">登录</span>
										</p>
									</div>
								</div>
								<div v-else @click="toTeachRoom">
									<p>
										您暂无权限播放本视频，请<span style="border-bottom: 1px solid #C43E32;color: #C43E32; padding: 0 0 2px 5px;">前往数字教研室查看</span>
									</p>
								</div>
								
								
							</div>
						</div>
						

						<div style="width:225px; display: flex;flex-direction:column;" v-if="detailData && detailData.is_office_product != 1">
							<div style="display: flex;flex-direction:column;" v-if="detailData.album_list && detailData.album_list.length>0">
								<div style="width: 100%; height: 50px; font-size: 20px;font-weight: 600;background: #333; display: flex; justify-content: center;align-items: center; color: #fff;">
									<i class="iconfont icon-guanlian" style="margin-right: 5px; margin-bottom: -3px; font-size: 22px;"></i>
									所属系列课
								</div>
								<div style="width: 100%; min-height: 105px; background-color: #ECECEC;  display: flex; flex-direction: column; justify-content: center;align-items: center;  padding:0 15px 15px 15px; box-sizing: border-box;">
									<div @click="toDetail(item)" style="font-size: 15px; line-height: 1.2; font-weight: 600; color: #333; margin-top: 15px; padding-bottom: 2px; border-bottom: 1px solid #333; cursor: pointer;" v-for="(item,index) in detailData.album_list">
										{{item.title}}
									</div>
								</div>
							</div>
							<div style="display: flex;flex-direction:column;">
								<div style="width: 100%; height: 50px; font-size: 20px;font-weight: 600;background: #333; display: flex; justify-content: center;align-items: center; color: #fff;">
									<i class="iconfont icon-guanlian" style="margin-right: 5px; margin-bottom: -3px; font-size: 22px;"></i>
									手机端观看
								</div>
								<div style="width: 100%; height: 256px; background-color: #ECECEC; border-radius: 0 0 50px 0; display: flex; flex-direction: column; justify-content: center;align-items: center; cursor: pointer;">
									<div ref="qrcode" style="width: 110px; height: 110px;"></div>
									<div style="font-size: 15px; font-weight: 600; color: #333; margin-top: 12px;">扫码观看课程</div>
								</div>
							</div>
						</div>

						<!-- <div style="width:225px; display: flex;flex-direction:column;" v-if="detailData && detailData.connection_book">
							<div style="width: 100%; height: 50px; font-size: 20px;font-weight: 600;background: #333; display: flex; justify-content: center;align-items: center; color: #fff;">
								<i class="iconfont icon-guanlian" style="margin-right: 5px; margin-bottom: -3px; font-size: 22px;"></i>
								相关图书
							</div>
							<div @click="toDetail(detailData.connection_book)" style="width: 100%; height: 256px; background-color: #ECECEC; border-radius: 0 0 50px 0; display: flex; flex-direction: column; justify-content: center;align-items: center; cursor: pointer;">
								<img style="width: 114px; height: 161px; box-shadow: 3px 5px 3px rgba(0,0,0,0.3);border: 1px solid #eee;" :src="detailData.connection_book.img_url" />
								<div style="width: 150px; display: flex; flex-direction: column; ">
									<div style="font-size: 15px; font-weight: 600; margin-top: 12px; white-space: nowrap; overflow: hidden;text-overflow: ellipsis;text-align: center;">{{detailData.connection_book.title}}</div>
									<div style="font-size: 12px;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;text-align: center;">{{detailData.connection_book.author}}</div>
								</div>
								
							</div>
						
						</div> -->
					</div>

					<div style="width: 100%; display: flex; flex-direction: row;margin-top: 40px; line-height: 1;">

						<div id="course_tab_main" class="course_tab_main" style=" width: 790px; margin-right: 35px; ">
							<div class="course_tab_items">
								<!-- <i class="el-icon-caret-right"></i> -->
								<div class="course_tab_item" @click="changeTab(1)" :class="{'actived':tab_index == 1}">课程目录
								</div>
								
								<div class="course_tab_item" @click="changeTab(2)" :class="{'actived':tab_index == 2}" v-if="detailData.file_count && detailData.file_count>0">课程资源
								</div>
								
								
								<div class="course_tab_item" @click="changeTab(3)" :class="{'actived':tab_index == 2}" v-if="detailData.connection_book">
									相关图书
								</div>
							</div>
							<div class="course_tab_conts">
								<div v-if="tab_index == 1" class="course_tab_cont">
									<div class="res_item" @click="getVideo(item,true)"
										:class="{'res_selected': listData && listData.current && listData.current.resource_id == item.resource_id}"
										v-for="(item,index) in listData.list">
										<div class="icon_box">
											<i class="iconfont icon-24gf-playCircle"></i>
										</div>
										<div class="mes_box">
											<div class="title_box">
												<div class="title">{{item.title}}</div>
												<div class="free_tag" v-if="item.is_try == 1">
													免费试看
												</div>
												<i class="el-icon-lock" style="margin-left: 10px;"
													v-if="item.is_try == 0 && item.is_available == 0"></i>
											</div>
											<div class="res_length">时长 {{ formatLength(item.video_length)}} <span v-if="item.is_curr_view ==1" style="margin-left: 10px;">已学 {{item.progress}}</span></div>
										</div>
										<div>
											<el-tag v-if="item.is_curr_view ==1" type="success">学习中</el-tag>
											<el-tag v-else-if="item.is_view ==1" type="info">
												已学{{item.progress}}
											</el-tag>
										</div>
									</div>
									
									<!-- 相关课程 -->
									<div style="display: flex; flex-direction: column;" v-if="detailData.class_product_list && detailData.class_product_list.length>0">
										<div class="course_tab_items">
											<div class="course_tab_item actived">
												相关课程
											</div>
										</div>
										<div class="res_item res_selected2" :class="{'actived':item.is_current == 1}" v-for="(item,index) in detailData.class_product_list" @click="toCourseDetail(item)">
											<div class="icon_box">
												<i class="iconfont icon-24gf-playCircle"></i>
											</div>
											<div class="mes_box">
												<div class="title_box">
													<div class="title">{{item.title}}</div>
												</div>
												<div class="res_length">时长 {{ formatLength(item.res_length)}}  <span v-if="item.is_current == 1" style="margin-left: 10px;">当前课程</span></div>
											</div>
											<div >
												<i class="el-icon-arrow-right" v-if="item.is_current == 0"></i>
												<i class="el-icon-top" v-if="item.is_current == 1"></i>
											</div>
										</div>
									</div>
								</div>
								
								<!-- 相关资源 -->
								<div v-if="tab_index == 2" class="course_tab_cont">
									<div class="res_item" :class="{'res_selected':file_selected && file_selected.id==item.id}" @click="downloadClick(item)" v-for="(item,index) in res_list">
										<div class="icon_box">
											<i class="iconfont icon-yunxiazai"></i>
										</div>
										<div class="mes_box">
											<div class="title_box">
												<div class="title">{{item.file_name}}</div>
											</div>
											<div class="res_length">文件大小 {{item.file_size}}</div>
										</div>
										<div>
											<el-tag v-if="file_selected && file_selected.id==item.id" type="success">下载中，请稍候</el-tag>
										</div>
									</div>
								</div>
								
								<!-- 相关图书 -->
								<div v-if="tab_index == 3" class="course_tab_cont">
									<div style=" width: 100%; padding: 30px 0; box-sizing: border-box;">
										<div
											style="width: 100%; width: 150px; height: 220px; display: flex; flex-direction: column; justify-content: center;align-items: center; cursor: pointer;">
											<img style="width: 114px; height: 161px; box-shadow: 3px 5px 3px rgba(0,0,0,0.3);border: 1px solid #eee;"
												:src="detailData.connection_book.img_url" />
											<div style="width: 150px; display: flex; flex-direction: column; ">
												<div
													style="font-size: 15px; font-weight: 600; margin-top: 12px; white-space: nowrap; overflow: hidden;text-overflow: ellipsis;text-align: center;">
													{{detailData.connection_book.title}}</div>
												<div
													style="font-size: 12px; margin-top: 5px; ;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;text-align: center;">
													{{detailData.connection_book.author}}</div>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
						<!-- <div style="flex: 1;">
							<div style="width: 100%;color: #666; border-bottom: 1px solid #666;height: 50px; line-height: 50px; font-size: 20px;font-weight: 600;">
								手机端观看
							</div>
							<div style="width: 100%; height: 180px; display: flex; flex-direction: column;justify-content: center;align-items: center; cursor: pointer;">
								<div ref="qrcode" style="width: 110px; height: 110px;"></div>
								<div style="font-size: 12px;color: #999; margin-top: 12px;">课程二维码</div>
							</div>

						</div> -->
					</div>


					<div v-if="detailData.desc" style="width: 100%; display: flex; flex-direction: row;margin-top: 20px; line-height: 1;">
						<div class="" style=" width: 790px; margin-right: 35px; ">
							<div style="color: #666; border-bottom: 1px solid #666;height: 50px; line-height: 50px; font-size: 20px; font-weight: 600;">
								<i class="el-icon-caret-right"></i>
								课程详情
							</div>
							<div  v-html="detailData.desc" style="width:100%;  display: flex;flex-direction: column; line-height: 1; padding: 20px 0;"></div>
						</div>
					</div>

				</div>
			</div>

			<!-- 购买提示 -->
			<el-dialog title="订阅课程" width="420px" top="28vh" :visible.sync="dialogQrVisible" :show-close="true">
				<div style=" width: 100%; height: 150px; display: flex; flex-direction: column;justify-content: center;align-items: center;">
					<div ref="qrcode2" style="width: 150px; height: 150px;"></div>
					<div style="margin-top: 10px;">
						请扫码二维码订阅本课程
					</div>
				</div>

				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogQrVisible = false">取消支付</el-button>
					<el-button type="primary" @click="finishedClick">支付完成</el-button>
				</div>
			</el-dialog>
		
		</div>
	</div>
</template>

<script>
	import QRCode from "qrcodejs2";
	import apiUrl from "../../js/apiUrl.js";
	import Player from 'xgplayer';
	import 'xgplayer/dist/index.min.css';
	//import ColorThief from 'colorthief';
	import download from 'downloadjs';

	export default {
		data() {
			return {
				detailSearch: {
					id: null,
					client_type: 10,
				},
				detailData: null,
				resourceSearch: {
					client_type: 10,
				},
				search: {
					product_id: '',
					page_index: 1,
					page_size: 80,
					client_type: 10	,	
					order_by: 'created_at:asc'
				},
				listData: {
					total: 1,
					count: 1,
					current: null,
					list: [],
				},
				read_timestamp: '',
				continue: false,
				isLogin: false,
				player: null,
				playerShow: false,
				dialogQrVisible: false,
				qrcode: null,
				qrcode2: null,
				priceShow: true,
				tab_index: 1,
				colorList:[
					{'bgColor':'#dae5cf','fontColor':'#90BC71'},
					{'bgColor':'#d1cfeb','fontColor':'#5861AB'},
					{'bgColor':'#dceof5','fontColor':'#5861AB'},
					{'bgColor':'#f6e2d3','fontColor':'#CE8F58'},
					{'bgColor':'#f5dbdf','fontColor':'#FB758B'},
					{'bgColor':'#ffdce2','fontColor':'#FB758B'},
				],
				colorSelected: null,
				res_list: [],
				file_selected:null,
			};
		},
		components: {
			qrcode: QRCode,
		},
		created() {
			document.title = "课程 - 机工教师特训营";
			this.isLogin = localStorage.getItem("userLogInInfo") ? true : false;
			console.log(this.isLogin);

			var option = {
				id: this.$route.query.id || "",
				tt_camp_id: this.$route.query.tt_camp_id || "",
				from: this.$route.query.from || "",
			};
			if (option.id) {
				this.search.product_id = option.id;
				this.detailSearch.id = option.id;
				if(option.tt_camp_id){
					this.detailSearch.tt_camp_id = option.tt_camp_id;
					this.resourceSearch.tt_camp_id= option.tt_camp_id;
				}
				if(option.from){
					this.detailSearch.album_id = option.from;
				}
				if(option.path){
					this.detailSearch.path = option.path;
				}
				this.getDetail();
			}
		},
		beforeDestroy() {
		    if (this.player) {
				this.stopPlayer();
				this.player.destroy();
		    }
		    this.removeProtection();
		},
		destroyed() {
			window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
			window.removeEventListener('unload', e => this.unloadHandler(e));
			window.removeEventListener('pagehide', e => this.pagehideHandler(e));
		},
		mounted() {
		    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
		    window.addEventListener('unload', e => this.unloadHandler(e));
			window.addEventListener('pagehide', e => this.pagehideHandler(e));
		},
		methods: {
			beforeunloadHandler(e){
				console.log('beforeunload');
				this.stopPlayer();
			},
			unloadHandler(e){
				console.log('unload');
				this.stopPlayer();
			},
			pagehideHandler(e){
				console.log('pagehide');
				this.stopPlayer();
			},
			downloadClick(item) {
				if(!item.file_path){
					this.$message({
						type: 'info',
						message: '请购买后下载'
					});
					return;
				}
				this.file_selected = item;
				download(item.file_path, item.file_name);
			},
			getCourseResList() {
				var that = this;
				var url = apiUrl.tt_course_res_list_get;
				var parm = {
					id: that.detailData.id,
					page_index: 1,
					page_size: 100,
					order_by: 'created_at:asc'
				};
				this.Ajax(url, parm, function(data) {
					that.res_list = data.list;
				});
			},
			getImageColor(dom, cv){
				cv.width = dom.width;
				cv.height = dom.height;
				const ctx =cv.getContext('2d')
				ctx.drawImage(dom,0,0);
				//获取图像像素点数据
				const data =ctx.getImageData(0,0, cv.width, cv.height).data;
				//将像素点转化成颜色数组
				const colorData =[];
				for(var i=0;i< data.length; i += 4){
					colorData.push(`${data[i]},${data[i + 1]},${data[i + 2]}`);
				}
				//将像素点去重并获取到对应的像素点数量
				const colorobj ={};
				colorData.forEach(val =>{
					if(colorobj[val]){
						colorobj[val] += 1
					} else {
						colorobj[val]=1
					}
				});
				//把去重的对象，转化成数组
				const arrKeys = Object.keys(colorobj);
				const colorArr =[];
				arrKeys.forEach(val =>{
					colorArr.push({
						[val]: colorobj[val]
					})
				});
				//排序
				colorArr.sort((a,b)=>{
					const akeys = Object.keys(a)[0]
					const bkeys = Object.keys(b)[0]
					return b[bkeys]- a[akeys]
				});
				//返回前2个色值
				return colorArr.slice(0,2);
			},
			ImgColor() {
				
				var that = this;
				let domImg = document.querySelector('#myImg'); // 获取图片dom节点
				console.log(domImg)
				//let colorthief = new ColorThief();
				that.colorSelected  = null;
				domImg.addEventListener('load', () => { // 图片加载
					//获取前2的色值(rgb格式)
					const imageColor = that.getImageColor(domImg, document.createElement('canvas'));
					//如果需要计算图像的色值(包含底色)建议选0下标，反之建议选1下标
					const obj= imageColor[0];
					const data = Object.keys(obj)[0].split(',');
					var _r = parseInt(data[0]);
					var _g = parseInt(data[1]);
					var _b = parseInt(data[2]);
					var _grayLevel = _r*0.299 + _g*0.587 + _b*0.114;
					console.log(_grayLevel);
					var _color = that.rgbToHex(_r,_g,_b);

					//console.log('主色调'+ this.rgbaToHex(colorthief.getColor(domImg))); //图片主色调，第二个参数可选(1~10)
					//var _color = this.rgbaToHex(colorthief.getColor(domImg));
					var _fontColor = '#333';
					if(_grayLevel < 192){//深色
						_fontColor = "#ffffff";
					}
					
					if(that.detailData.id == 'p_6503c367277ae1c46129a4b1' || 
					that.detailData.id == 'p_650ae33546026b8418fbe549' || 
					that.detailData.id == 'p_650d2431ea3c4c64a909444d' || 
					that.detailData.id == 'p_650da030abee2fa43bc92230' ||
					that.detailData.id == 'p_6505dfe05dec0b54c58929c0' ){
						_color = '#d3d7f2';
						_fontColor = '#333';
					}
					
		
					
					console.log('主色调'+ _color);
					console.log('字体颜色'+ _fontColor);
					
					
					that.colorSelected = {'bgColor':_color,'fontColor':_fontColor};
					
					
					/*
					that.colorList.forEach((item,index)=>{
						if(item.bgColor == _color){
							that.colorSelected = item;
							console.log('that.colorSelected'+JSON.stringify(item))
						}
					})
					if(!that.colorSelected){
						if(_color!=''){
							switch(_color){
								case '#454051':
								case '#3d3c42':
								case '#313439':
								case '#1a1a1e':
								case '#1f1d21':
								case '#282b3c':
									that.colorSelected = that.colorList[0];
									break;
								
								case '#2d3643':
								case '#2b3041':
								case '#2e3a55':
								case '#1b1a1e':
								case '#1d232f':
								case '#342f44':
									that.colorSelected = that.colorList[1];
									break;
									
								case '#f8ded9':
								case '#8b6151':
								case '#1f1725':
									that.colorSelected = that.colorList[2];
									break;
									
								case '#2e3356':
								case '#44454b':
									that.colorSelected = that.colorList[3];
									break;
									
								default :
									that.colorSelected = {'bgColor':_color,'fontColor':'#333'};
									break;
							}
						}else{
							that.colorSelected = that.colorList[0];
						}
					}
					*/
				})
			},
			rgbToHex(red, green, blue) {
			  const toHex = (colorValue) => {
			    const hex = colorValue.toString(16);
			    return hex.length == 1 ? "0" + hex : hex;
			  };
			 
			  return "#" + toHex(red) + toHex(green) + toHex(blue);
			},
			rgbaToHex(rgba) { // rgba转16进制
				let hex = '#';
				for (const i of rgba) {
					hex += i.toString(16).padStart(2, '0');
				}
				return hex;
			},
			changeTab(index) {
				this.tab_index = index;
			},
			toCourseDetail(item){
				if(item.is_current == 1){
					this.scrollToAnchor('videoContainer');
				}else{
					this.GoToDetail(item.product_type,item.product_id);
				}
			},
			scrollToAnchor(id) {
				const element = document.getElementById(id);
				element.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				});
			},
			toTeachRoom() {
				this.GoToDetail(this.detailData.office_info.product_type,this.detailData.office_info.id);
			},
			toLogin() {
				//window.top.location.href = "/login";
				this.$router.push({ path: '/login' });
			},
			showQrClick() {
				if (this.isLogin) {
					
					if(this.detailData.status && this.detailData.status.status_code == 3){
						
						this.$confirm(this.detailData.status.status_msg, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							// this.$message({
							// 	type: 'info',
							// 	message: '兑换中，请稍候...'
							// });
							this.redeemConfirmClick();
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消',
								duration: 1000,
							});
						});
						
					}else{
						
						this.dialogQrVisible = true;
						var that = this;
						if (!that.qrcode2) {
							that.$nextTick(() => {
								that.setupQrCode(that.$refs.qrcode2, that.detailData.qrcode_url, 150, (code_img) => {
									that.qrcode2 = code_img;
								});
							});
						}
						
					}
					
				} else {
					var msg_title = "您需要登录后才可以订阅，是否登录?";
					this.$confirm(msg_title, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						//window.top.location.href = "/login";
						this.$router.push({ path: '/login' });
					}).catch(() => {
						// this.$message({
						// 	type: 'info',
						// 	message: '已取消'
						// });
					});
				}
			},
			redeemConfirmClick() {
				var that = this;
				this.Ajax(apiUrl.purchase_add, {
					product_id: that.detailData.id,
					product_type: that.detailData.product_type,
				}, function(data) {
					that.$message({
						type: 'success',
						message: '兑换成功',
						duration: 1000,
					});
					that.getDetail();
				});
			},
			finishedClick() {
				this.dialogQrVisible = false;
				this.getResList();
			},
			play() {
				var that = this;
				
				if (!that.player) {
					if(that.listData.current.video_url){
						var player = new Player({
							"id": 'mse',
							"url": that.listData.current.video_url,
							"poster":'https://images.cmptt.com/h5/cmptt/course/player_poster.png',
							'fluid': true,
							'controls': true,
							'download': false,
							'lastPlayTime':0,
							'lastPlayTimeHideDelay':5,
							'volume': 0.3,
							'videoInit': true,
							'playsinline': true,
							'playbackRate': [0.5, 0.75, 1, 1.5, 2],
							'defaultPlaybackRate': 1,
							'x5-video-player-type': 'h5',
							'x5-video-orientation': 'portraint',
							"lang": 'zh-cn',
							'commonStyle': {
								'playedColor': '#C43D31',
								'volumeColor': '#C43D31'
							}
						});
						that.player = player;
						that.player.controlsList ='nodownload';
						if(that.continue){
							that.player.currentTime = 0;
						}else{
							that.player.currentTime = that.listData.current.curr_time;
							that.player.lastPlayTime = that.listData.current.curr_time;
						}
						//视频可以播放
						that.player.on("canplay", () => {
							console.log('视频可以播放了');
							if(that.player.autoplay){
								that.player.play();
							}
						});
						//播放
						that.player.on("play", () => {
							this.read_timestamp = Date.parse(new Date());
							console.log('开始播放 '+this.read_timestamp);
						});
						//暂停
						that.player.on("pause", () => {
							console.log('暂停');
							this.stopPlayer();
						});
						//结束
						that.player.on("ended", () => {
							console.log('结束');
							//this.stopPlayer();
							this.next();
						});
						//seek完成
						that.player.on("seeked", () => {
							console.log('拖动完成');
						});
						that.setupProtection();
					}
				} else {
					that.player.src = that.listData.current.video_url;
					that.player.autoplay = true;
					that.player.controlsList ='nodownload';
					if(that.continue){
						that.player.currentTime = 0;
					}else{
						that.player.currentTime = that.listData.current.curr_time;
						that.player.lastPlayTime = that.listData.current.curr_time;
					}
				}
			},
			//停止播放记录当前时间
			stopPlayer(info) {
				if(!this.isLogin){
					return;
				}
				var now_timestamp = Date.parse(new Date()); //当前时间戳
				var duration = (now_timestamp - this.read_timestamp) / 1000; //阅读时间，单位秒
				if (!info || !info.resource_id) {
					var curr_time = this.player.currentTime;
					info = {
						product_id: this.listData.current.product_id || "",
						resource_id: this.listData.current.resource_id || "",
						curr_time: parseInt(curr_time) || 0,
						duration: duration,
					}
				} else {
					info = {
						product_id: info.product_id || "",
						resource_id: info.resource_id || "",
						curr_time: parseInt(info.curr_time) || 0,
						duration: duration,
					}
				}
				//console.log('info'+ JSON.stringify(info));
				if (info.resource_id != '' && !isNaN(info.curr_time) && !isNaN(info.duration)) {
					this.Ajax(apiUrl.resource_progress_update, info, (data) => {
						//Todo 测试是否记录成功
						this.read_timestamp = now_timestamp;
						//更新浏览状态
						this.listData.list.forEach((item, index) => {
							if (item.product_id == info.product_id && item.resource_id == info.resource_id) {
								item.is_view = 1;
								item.progress = data.progress;
							}
						});
					});
				}
			
			},
			toDetail(item) {
				this.GoToDetail(item.product_type,item.id);
			},
			formatLength(length) {
				var result = '';
				var values = length.split(':');
				switch (values.length) {
					case 1:
						result = values[0] + '秒';
						break;
					case 2:
						result = values[0] + '分' + values[1] + '秒';
						break;
					case 3:
						result = values[0] + '时' + values[1] + '分' + values[2] + '秒';
						break;

					default:
						result = '';
						break;
				}
				return result;
			},
			next(){
				var last_item = this.listData.list[this.listData.current.index-1];
				last_item.is_curr_view  = 0;
				last_item.is_view  = 1;
				last_item.progress = '100%';
				
				if(!this.isLogin){
					return;
				}
				if(this.listData.current.index == this.listData.list.length){
					return;
				}
				var item = this.listData.list[this.listData.current.index];
				if(item.is_available == 0 && item.is_try == 0){
					return;
				}
				this.continue = true;
				this.getVideo(item);
			},
			getDetail() {
				var that = this;
				var url = apiUrl.tt_course_detail_get;
				this.Ajax(url, that.detailSearch, (data) => {
					that.detailData = data;
					if(that.detailData.is_office_product == 1){
						that.priceShow = false;
					}

				
					that.detailData.qrcode_url ='https://m.cmptt.com/pages/course/courseDetails?id='+that.detailSearch.id
					document.title = data.title + " - 课程 - 机工教师特训营";
					that.$nextTick(() => {
						that.ImgColor();
					});
					
					
					if (data.qrcode_url && data.qrcode_url != "" && !that.qrcode) {
						that.$nextTick(() => {
							that.setupQrCode(this.$refs.qrcode, data.qrcode_url, 110, (code_img) => {
								that.qrcode = code_img;
							});
						});
					}
					
					var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
					if (userInfo) {
						userInfo.cart_product_count = that.detailData.cart_product_count;
						localStorage.setItem("userLogInInfo", JSON.stringify(userInfo));
					}
					
					that.search.page_index == 1;
					that.getResList();
	
					if(data.file_count && data.file_count>0){
						that.getCourseResList();
					}
				});
			},
			getResList() {
				var that = this;
				var url = apiUrl.resource_list_get;
				this.Ajax(url, this.search, (data) => {
					if (that.listData.total == 0) {
						that.listData.total = data.total;
					}
					if (that.listData.count == 0) {
						that.listData.count = data.count;
					}
					if(that.search.page_index == 1){
						that.listData.list = [];
					}
					that.listData.list = that.listData.list.concat(data.list);
					if (that.search.page_index == 1) {
						var is_load = false;
						that.listData.list.forEach((item,index)=>{
							if(item.is_curr_view == 1 && item.is_available == 1){
								is_load = true;
								that.getVideo(item);
							}
						});
						if(!is_load){
							that.getVideo(that.listData.list[0]);
						}
					}
					
					if(!that.detailData.status || (that.detailData.status &&that.detailData.status.status_code != 1)){
						that.listData.list.forEach((item,index)=>{
							if(item.is_curr_view == 1){
								item.is_curr_view =0;
							}
							if(item.is_view == 1){
								item.is_view = 0;
							}
						});
					}
				});
			},
			videoPlayClick(item){
				this.continue = false;
				this.getVideo(item,true);
			},
			getVideo(item, alert) {
				if (this.listData && this.listData.current && this.listData.current.video_url != '' && this.listData
					.current.resource_id == item.resource_id) {
					return;
				}
				this.playerShow = true;
				if (item.is_try == 0 && item.is_available == 0) {
					this.playerShow = false;
					if (alert) {
						if(this.detailData.is_office_product == 1){
							this.$confirm('您暂无权限播放本视频, 前往数字教研室可查看', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.toTeachRoom();
							}).catch(() => {
								// this.$message({
								// 	type: 'info',
								// 	message: '已取消'
								// });
							});
							
						}else{
							if (this.isLogin) {
							
								this.showQrClick();
								
								// if(this.detailData.status &&this.detailData.status.status_code == 3){
								// 	this.$alert('您暂无权限播放本视频, 请兑换', '提示', {
								// 		confirmButtonText: '确定'
								// 	});
								// }else{
								// 	this.$alert('您暂无权限播放本视频, 请订阅', '提示', {
								// 		confirmButtonText: '确定'
								// 	});
								// }
								
							} else {
								var msg_title = "您暂无权限播放本视频, 是否登录订阅?";
								if (this.detailData.price == '0.00') {
									msg_title = "您暂无权限播放本视频，登录后即可播放，是否登录?";
								}
								this.$confirm(msg_title, '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									this.toLogin();
								}).catch(() => {
									// this.$message({
									// 	type: 'info',
									// 	message: '已取消'
									// });
								});
							}
						}
						return;
					}
				}

				//播放器已经初始化而且不是连续播放
				if(!this.continue && this.player){
					this.stopPlayer();
				}
				
				var that = this;
				var url = apiUrl.resource_detail_get;
				that.resourceSearch.product_id = item.product_id;
				that.resourceSearch.resource_id = item.resource_id;
				this.Ajax(url,that.resourceSearch , (data) => {
					that.listData.current = data;
					that.listData.list.forEach((item, index) => {
						if(item.is_curr_view == 1){
							item.is_curr_view = 0;
						}
					});
					that.listData.list.forEach((item, index) => {
						if (item.resource_id == data.resource_id) {
							that.listData.current.index = index + 1;
							item.is_curr_view = 1;
							item.is_view = 1;
						}
						if (index == 0 && item.is_available == 1) {
							that.priceShow = false;
							console.log(that.priceShow)
						}
					})
					that.play();
				});
			},
			//QrCode
			setupQrCode(el, url, width, callback) {
				let code_img = new QRCode(el, {
					width: width,
					height: width, // 高度
					text: url, // 二维码内容
					colorDark: '#333333',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.L,
				});
				if (callback) callback(code_img);
			},
			cartAddClick(){
				if (this.isLogin) {
					var that = this;
					var url = apiUrl.tt_course_cart_add;
					var parm = { product_id: that.detailData.id , product_type: that.detailData.product_type };
					this.Ajax(url, parm, function(data) {
						that.detailData.cart_product_count = data.cart_product_count;
						//更新顶部购物车中产品数量
						that.$emit('updateCartProductCount', that.detailData.cart_product_count);
						that.detailData.is_cart_product = 1;
						that.$message({
						  showClose: true,
						  message: '已添加进购物车',
						  type: 'warning'
						});
						var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
						if (userInfo) {
							userInfo.cart_product_count = that.detailData.cart_product_count;
							localStorage.setItem("userLogInInfo", JSON.stringify(userInfo));
						}		
					});
				} else {
					this.$router.push({ path: '/login' });
				}
			},
			cartDelClick(){
				if (this.isLogin) {
					var that = this;
					var url = apiUrl.tt_course_cart_del;
					var parm = { product_id: that.detailData.id , product_type: that.detailData.product_type };
					this.Ajax(url, parm, (data)=> {
						that.detailData.cart_product_count = data.cart_product_count;
						//更新顶部购物车中产品数量
						that.$emit('updateCartProductCount', that.detailData.cart_product_count);
						that.detailData.is_cart_product = 0;
						that.$message({
						  showClose: true,
						  message: '已移除出购物车',
						  type: 'warning'
						});
						
						var userInfo = JSON.parse(localStorage.getItem("userLogInInfo"));
						if (userInfo) {
							userInfo.cart_product_count = that.detailData.cart_product_count;
							localStorage.setItem("userLogInInfo", JSON.stringify(userInfo));
						}	
					});
				} else {
					this.$router.push({ path: '/login' });
				}
			},
			setupProtection() {
			      // 阻止视频元素的右键菜单
			      const videoElement = this.$refs.videoContainer.querySelector('video')
			      if (videoElement) {
			        videoElement.addEventListener('contextmenu', this.handleContextMenu)
			        // 禁用右键菜单
			        videoElement.oncontextmenu = () => false
			        
			        // 防止开发者工具查看视频地址
			        Object.defineProperty(videoElement, 'src', {
			          writable: false
			        })
			      }
			      
			      // 监听全局键盘事件
			      window.addEventListener('keydown', this.handleGlobalKeyDown)
			},
			removeProtection() {
			  window.removeEventListener('keydown', this.handleGlobalKeyDown)
			},
			handleContextMenu(e) {
			  e.preventDefault()
			  return false
			},
			handleGlobalKeyDown(e) {
			  // 阻止保存网页的快捷键
			  if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'S')) {
				e.preventDefault()
				e.stopPropagation()
				return false
			  }
			  // 阻止打印（可能包含视频）
			  if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
				e.preventDefault()
				e.stopPropagation()
				return false
			  }
			},
			
		},
	};
</script>



<style lang="scss" scoped>
	.course_detail_container {
		width: 100%;
		min-height: 100vh;
		background: #fff;
		
		.xgplayer .xg-options-list li:hover,
		.xgplayer .xg-options-list li.selected {
			color: #C43D31;
			opacity: 1;
		}
		
		.course_tab_main {
			
			.course_tab_items {
				color: #666;
				border-bottom: 1px solid #666;
				height: 50px;
				line-height: 50px;
				font-size: 20px;
				font-weight: 600;
				display: flex;

				.course_tab_item {
					display: inline-flex;
					height: 50px;
					line-height: 50px;
					box-sizing: border-box;
					cursor: pointer;

					&:hover {
						color: #FF7A39;
					}

					&.actived {
						border-bottom: 3px solid #FF7A39;
					}
				}

				.course_tab_item+.course_tab_item {
					margin-left: 30px;
				}

				.course_tab_conts {
					display: flex;
					flex-direction: column;

					.course_tab_cont {
						width: 100%;
						display: flex;
						flex-direction: column;
						line-height: 1;
						padding: 10px 0;
					}
				}


			}
		}

		.res_item {
			margin-top: 10px;
			width: 100%;
			height: 60px;
			padding: 12px 20px;
			box-sizing: border-box;
			display: flex;
			flex-direction: row;
			cursor: pointer;

			.icon_box {
				color: #ccc;
				margin-right: 15px;
			}
			
			.el-tag{
				width: 90px !important;
				display: inline-flex;
				justify-content: center;
			}

			.mes_box {
				color: #ccc;
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.title_box {
					width: 100%;
					display: flex;
					flex-direction: row;

					.title {
						font-size: 18px;
						font-weight: 500;
					}

					.free_tag {
						background-color: #FF7A39;
						color: #fff;
						font-size: 10px;
						padding: 4px 8px;
						border-radius: 10px 10px 10px 0;
						position: relative;
						margin-left: 10px;

						&::before {
							content: '';
							position: absolute;
							bottom: 0;
							left: -5px;
							border-top: 5px solid transparent;
							border-right: 5px solid #FF7A39;
							border-bottom: 5px solid #FF7A39;
							border-left: 5px solid transparent;
						}
					}
				}

				.res_length {
					font-size: 10px;
				}
			}

			&.res_selected,
			&:hover {
				background-color: #FDF4F3 !important;
				
				.mes_box {
					.title_box {
						.title {
							color: #C43E32 !important;
						}
					}
					
					.res_length {
						color: #C43E32 !important;
					}
				}

				.icon_box {
					color: #C43E32 !important;
				}

				.mes_box {
					color: #999 !important;
				}
			}
			
			&.res_selected2{
				background-color: #f5f5f5 !important;
				
				.mes_box {
					.title_box {
						.title {
							color: #333 !important;
						}
					}
					
					.res_length {
						color: #999 !important;
					}
				}
				
				.icon_box {
					color: #999 !important;
				}
				
				.mes_box {
					color: #999 !important;
				}
				
				&.actived,
				&:hover {
					background-color: #FDF4F3 !important;
					
					.mes_box {
						.title_box {
							.title {
								color: #C43E32 !important;
							}
						}
						
						.res_length {
							color: #C43E32 !important;
						}
					}
				
					.icon_box {
						color: #C43E32 !important;
					}
				
					.mes_box {
						color: #999 !important;
					}
				}
			}
		}



		.mianb {
			width: 100%;
			height: 75px;
			margin: 0 auto;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-size: 18px;
			font-family: PingFang-SC-Medium, PingFang-SC;
			font-weight: 500;
			color: #C43E32;


			.el-breadcrumb {
				font-size: 16px;
			}

			.el-breadcrumb__inner a,
			.el-breadcrumb__inner.is-link,
			.el-breadcrumb__separator {
				color: #C43E32 !important;

			}

			.el-breadcrumb__inner.is-link:hover {
				border-bottom: 1px solid #C43E32;
			}

			.el-breadcrumb__item:last-child .el-breadcrumb__inner {
				color: #C43E32 !important;
			}

		}
	}
</style>